import {IModel, IOn2ServerConfig, ISlsOrdClient} from "../kova/slsordClient";
import {createContext, useContext, useEffect, useState} from "react";


export const ModelSourceContext = createContext<IModelSource|null>(null);


export interface IModelSource {
    fetchModels(): Promise<IModel[]>;
    fetchOptContext(modelId:string): Promise<string>;

}
class ModelClient {

    private readonly serverUri: string;

    constructor(config: IOn2ServerConfig) {
        this.serverUri = config.serverUri;
    }

    async fetchModels(): Promise<IModel[]> {
        let uri = `${this.serverUri}models`;
        const response = await fetch(uri);
        const result = await response.json() as IModel[];
        return result;
    }
    async fetchOptContext(modelId:string): Promise<string> {
        let uri = `${this.serverUri}model/${encodeURIComponent(modelId)}/optContext`;
        const response = await fetch(uri);
        const resultText = await response.text();
        return resultText;
    }
}

export function useModels() {
    const modelClient = useContext(ModelSourceContext);
    const [models, setModels] = useState<IModel[]|null>(null);
    useEffect(() => {
        if (modelClient === null) throw new Error('Unable to useModels if ModelSourceContext is not initialized');
        modelClient.fetchModels().then(res => setModels(res));
    }, []);
    return models;
}

export function useModelOptContext(modelId:string) {
    const modelClient = useContext(ModelSourceContext);
    const [modelContext, setModelContext] = useState<string|null>(null);
    useEffect(() => {
        if (modelClient === null) throw new Error('Unable to useModels if ModelSourceContext is not initialized');
        modelClient.fetchOptContext(modelId).then(res => setModelContext(res));
    }, []);
    return modelContext;
}
export default ModelClient;